import {
  CheckboxProps as ChakraCheckboxProps,
  Checkbox as ChakraCheckbox,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

type CheckboxProps = ChakraCheckboxProps & { params?: string[] };

export const Checkbox: React.FC<CheckboxProps> = ({
  params,
  children,
  ...props
}) => {
  const translate = useTranslate();
  return (
    <ChakraCheckbox {...props} borderColor="#807a7a">
      {translate(children, params)}
    </ChakraCheckbox>
  );
};
